export const getStartFormIndex = (processDefinitionId: string, taskFormKey?: string) =>
    taskFormKey ? `${processDefinitionId}|${taskFormKey}` : processDefinitionId;
